<div class="breadcrumbs-container mb-10" *ngIf="breadcrumbs.length > 1">
  <span class="breadcrumb" *ngFor="let breadcrumb of breadcrumbs">
    <span class="cursor text-primary"
          [routerLink]="'/'+breadcrumb.url">{{ breadcrumb.breadcrumb | translate }}</span>&nbsp;
    <span class="breadcrumb-separator">/</span>&nbsp;
  </span>
</div>
